import React, { useState } from 'react';
import { Row, Col, size } from '@everlywell/leaves';
import { useSpring, config } from 'react-spring';

import { useScrolledIntoViewOnce } from 'utils/hooks';

import OrangeArch from './images/orangeArch.svg';

import * as S from './styles';

export interface OutreachSectionProps {
  headline: string;
  mainCta: {
    text: string;
    url: string;
  };
}

export const PartnerSection: React.FC<OutreachSectionProps> = ({
  headline,
  mainCta,
}) => {
  const [sectionInView, setSectionInView] = useState(false);

  const sectionEl = useScrolledIntoViewOnce(() => {
    setSectionInView(true);
  });

  // triggered from scrolling into view
  const sectionTransition = useSpring({
    opacity: sectionInView ? 1 : 0,
    transform: sectionInView ? 'translateY(0)' : `translateY(${size.xl3}px)`,
    config: config.slow,
    delay: () => (sectionInView === true ? 750 : 0),
  });

  const archTransition = useSpring({
    transform: sectionInView ? 'rotate(0deg)' : 'rotate(-180deg)',
    config: { tension: 280, friction: 70 },
  });
  return (
    <S.Container>
      <S.Inner ref={sectionEl}>
        <S.TextContainer style={sectionTransition}>
          <Row center="xs">
            <Col xs={12} lg={10}>
              <S.HeadlineText>{headline}</S.HeadlineText>
            </Col>
          </Row>
          <Row center="xs">
            <Col xs={12} lg={6}>
              <S.Button href={mainCta.url} appearance="primary">
                {mainCta.text}
              </S.Button>
            </Col>
          </Row>
        </S.TextContainer>
        <S.Graphic aria-hidden="true" style={archTransition} src={OrangeArch} />
      </S.Inner>
    </S.Container>
  );
};

export default PartnerSection;
